(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/barcode/components/barcode-print.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/barcode/components/barcode-print.js');
"use strict";


const _React = React,
  Fragment = _React.Fragment;
const BarcodePrint = _ref => {
  let giftCode = _ref.giftCode,
    extraGiftCodes = _ref.extraGiftCodes,
    manual = _ref.manual,
    numberOfTickets = _ref.numberOfTickets,
    totalPrice = _ref.totalPrice,
    expirationDate = _ref.expirationDate;
  const Brand = svs.ui.ReactBrand;
  const ManualInfo = svs.ticket_gifts.barcode.components.ManualInfo;
  React.useEffect(() => {
    JsBarcode('#js-voucher-barcode', "VV".concat(giftCode), {
      format: 'code128',
      width: 2,
      displayValue: false
    });
  }, [giftCode]);
  React.useEffect(() => {
    extraGiftCodes === null || extraGiftCodes === void 0 || extraGiftCodes.forEach((code, index) => {
      JsBarcode("#js-voucher-barcode-".concat(index), "VV".concat(code), {
        format: 'code128',
        width: 2,
        displayValue: false
      });
    });
  }, [extraGiftCodes]);
  let subheader = null;
  switch (true) {
    case Number(numberOfTickets) === 1 && totalPrice:
      subheader = "1 lott till ett v\xE4rde av ".concat(totalPrice, " kr");
      break;
    case numberOfTickets > 1 && totalPrice:
      subheader = "".concat(numberOfTickets, " lotter till ett v\xE4rde av ").concat(totalPrice, " kr");
      break;
    default:
  }
  return React.createElement("div", {
    className: "barcode-print-container"
  }, !extraGiftCodes && React.createElement("div", {
    className: "f-500 barcode-print-top-info"
  }, "V\xE4rdekod - Uppge koden f\xF6r ditt spelombud eller visa den och streckkoden f\xF6r inl\xE4sning."), extraGiftCodes && React.createElement("div", {
    className: "f-500 barcode-print-top-info"
  }, "V\xE4rdekoder - Uppge koderna f\xF6r ditt spelombud eller visa dem och streckkoderna f\xF6r inl\xE4sning."), React.createElement("div", {
    className: "barcode-print-content"
  }, React.createElement("div", {
    className: "barcode-print-brand padding-top-2 padding-bottom-2"
  }, React.createElement(Brand, {
    brand: "svenskaspel-twolines",
    emblem: true
  })), !extraGiftCodes && React.createElement("div", {
    className: "f-900"
  }, "V\xE4rdekod"), extraGiftCodes && React.createElement("div", {
    className: "f-900"
  }, "V\xE4rdekoder"), subheader && React.createElement("div", {
    className: "f-700 f-bold"
  }, subheader), !extraGiftCodes && React.createElement("div", {
    className: "padding-2 f-700 f-normal"
  }, "Scanna streckkoden under kundsk\xE4rmen i din spelbutik, eller uppge koden f\xF6r kassapersonalen"), extraGiftCodes && React.createElement("div", {
    className: "padding-2 f-700 f-normal"
  }, "Scanna streckkoderna under kundsk\xE4rmen i din spelbutik, eller uppge koderna f\xF6r kassapersonalen"), expirationDate && React.createElement("div", {
    className: "f-bold margin-bottom-2"
  }, "Giltig till: ".concat(expirationDate)), React.createElement("div", {
    className: "f-800"
  }, giftCode && giftCode.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), manual && React.createElement(ManualInfo, null), React.createElement("div", {
    className: manual ? 'padding-top-1' : 'padding-2'
  }, React.createElement("img", {
    id: "js-voucher-barcode"
  })), extraGiftCodes === null || extraGiftCodes === void 0 ? void 0 : extraGiftCodes.map((code, index) => React.createElement(Fragment, {
    key: code
  }, React.createElement("div", {
    className: "f-800"
  }, code && code.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), React.createElement("div", {
    className: "padding-2"
  }, React.createElement("img", {
    id: "js-voucher-barcode-".concat(index)
  })))), !extraGiftCodes && React.createElement("div", {
    className: "f-700 f-normal padding-1 padding-top-0"
  }, "Koden \xE4r en v\xE4rdehandling tills dina lotter \xE4r uth\xE4mtade."), extraGiftCodes && React.createElement("div", {
    className: "f-700 f-normal padding-1 padding-top-0"
  }, "Koderna \xE4r v\xE4rdehandlingar tills dina lotter \xE4r uth\xE4mtade."), React.createElement("div", {
    className: "f-700 f-bold padding-1"
  }, "Beh\xF6ver du hj\xE4lp?"), React.createElement("div", {
    className: "f-700 f-normal padding-bottom-1"
  }, "Kontakta Kundservice. Telefon 0770-11 11 11.")));
};
setGlobal('svs.ticket_gifts.barcode.components.BarcodePrint', BarcodePrint);

 })(window);